"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ftnv = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var zl_1 = require("../../model/zl");
var service_1 = require("../../../library/base/service");
var Ftnv = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Ftnv, _super);
    function Ftnv() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '众禄基金实时走势';
        _this.code = '106021';
        _this.desc = '众禄基金实时走势';
        _this.requestParams = new zl_1.FtnvRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Ftnv;
}(service_1.BaseService));
exports.Ftnv = Ftnv;
//# sourceMappingURL=ftnv.js.map